import { createApp } from 'vue';
import DngToJpgConverter from '../Components/DngToJpgConverter.vue';

const root = document.getElementById('dng-to-jpg-converter');
if (root) {
  createApp(DngToJpgConverter).mount('#dng-to-jpg-converter');
}
